import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Modal } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change } from 'redux-form';

// Components
import MoreFilters from '../SearchListing/Filters/MoreFilters';

// Helpers
import messages from '../../locale/messages';
import { closeMoreFiltersModal } from '../../actions/modalActions';

// Style
import s from './MoreFiltersModal.css';

class MoreFiltersModal extends Component {
    static propTypes = {
        closeLoginModal: PropTypes.func,
        filtersModal: PropTypes.bool,
        closeMoreFiltersModal: PropTypes.func,
        formatMessage: PropTypes.func,
    };

    render() {
        const { handleTabToggle, closeMoreFiltersModal, isExpand, searchSettings, smallDevice, filtersModal, tabletDevice } = this.props;

        return (
            <div>
                <Modal
                    show={filtersModal}
                    animation={false}
                    onHide={closeMoreFiltersModal}
                    dialogClassName={cx(s.logInModalContainer, 'moreFilterModal', 'moreFilter')}
                    backdrop="static"
                >
                    <Modal.Header closeButton className={s.panelHeader}>
                        <Modal.Title>
                            <span><FormattedMessage {...messages.moreFilters} /></span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body bsClass={s.logInModalBody}>
                        <div>
                            <MoreFilters
                                handleTabToggle={handleTabToggle}
                                isExpand={isExpand}
                                searchSettings={searchSettings}
                                smallDevice={smallDevice}
                                tabletDevice={tabletDevice}
                            />
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}


const mapState = state => ({
    filtersModal: state.modalStatus.isMoreFiltersModal,
    userData: state.account.data,
});

const mapDispatch = {
    closeMoreFiltersModal,
    change
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(MoreFiltersModal)));